import {
  BrandAirPlaySecurityProfileConfiguration,
  LocationAirPlaySecurityProfileConfiguration,
  RoomAirPlaySecurityProfileConfiguration,
} from '@era/settings-sdk';
import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { CategoryType } from '../shared/types';

export interface CategoryAirplaySecurityProfileConfiguration {
  type: CategoryType;
  id: string;
  airPlaySecurityProfilePresetId: string;
  displayName: string;
}

type AnyAirplaySecurityProfileConfiguration =
  | BrandAirPlaySecurityProfileConfiguration
  | LocationAirPlaySecurityProfileConfiguration
  | RoomAirPlaySecurityProfileConfiguration;

/**
 * Generic function to convert any airplay security profile configuration to the unified format.
 * Automatically determines the category type and ID based on the input configuration.
 */
export function airplaySecurityProfileFrom(
  configuration: AnyAirplaySecurityProfileConfiguration
): CategoryAirplaySecurityProfileConfiguration {
  // Type guard functions to determine the category type
  if ('brandId' in configuration) {
    return {
      type: 'Brand',
      id: configuration.brandId,
      airPlaySecurityProfilePresetId: configuration.airPlaySecurityProfilePresetId,
      displayName: configuration.displayName,
    };
  }
  if ('locationId' in configuration) {
    return {
      type: 'Location',
      id: configuration.locationId,
      airPlaySecurityProfilePresetId: configuration.airPlaySecurityProfilePresetId,
      displayName: configuration.displayName,
    };
  }
  if ('roomId' in configuration) {
    return {
      type: 'Room',
      id: configuration.roomId,
      airPlaySecurityProfilePresetId: configuration.airPlaySecurityProfilePresetId,
      displayName: configuration.displayName,
    };
  }
  throw new Error('Unknown airplay security profile configuration type');
}

export type CategoryAirplaySecurityProfileState = EntityState<CategoryAirplaySecurityProfileConfiguration>;

export function selectId(configuration: CategoryAirplaySecurityProfileConfiguration): string {
  return `${configuration.type}-${configuration.id}-${configuration.airPlaySecurityProfilePresetId}`;
}

export const adapter: EntityAdapter<CategoryAirplaySecurityProfileConfiguration> =
  createEntityAdapter<CategoryAirplaySecurityProfileConfiguration>({
    selectId,
  });

export const initialState: CategoryAirplaySecurityProfileState = adapter.getInitialState();
